import { render, staticRenderFns } from "./AfterSalePick.vue?vue&type=template&id=7c695d6b"
import script from "./AfterSalePick.vue?vue&type=script&lang=js"
export * from "./AfterSalePick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports